import React, { MouseEvent } from 'react';
import { ReactComponent as HeadphonesIcon } from 'media/icons/headphones.svg';
import { ReactComponent as ListIcon } from 'media/icons/list.svg';
import { BooksType } from 'components/Books/card/BooksCardTypes';
import { useHistory } from 'react-router-dom';
import { vsprintf } from 'sprintf-js';
import RoutePath from 'routes/constants/routes';
import { getAuthorsLabel } from 'utils/books';
import placeholder from 'media/images/placeholder.jpg';
import { textTrim } from 'utils/text';
import { useMediaQuery } from 'react-responsive';
import Breakpoints from 'themes/constants/breakpoints';
import { ButtonThemeType } from 'components/Button/Button';
import useTranslate from 'hooks/useTranslate';
import { ITheme } from 'themes/constants/themes';
import { useTheme } from 'styled-components/macro';
import { setAudioData } from 'redux/actions/audio/audioActions';
import { useDispatch } from 'react-redux';
import { BooksCardBigThemeType, IBooksCardBigProps } from './BooksCardBigTypes';
import {
  BooksCardBigCaption,
  BooksCardBigCaptionAuthors,
  BooksCardBigCaptionName,
  BooksCardBigContainer,
  BooksCardBigCover,
  BooksCardBigCoverImg,
  BooksCardBigCoverInner,
  BooksCardBigCoverCaption,
  BooksCardBigButtons,
  BooksCardBigButton,
} from './BooksCardBigStyles';

function BooksCardBig(props: IBooksCardBigProps) {
  const {
    item,
    themeType = BooksCardBigThemeType.PRIMARY,
    priorityPreview = BooksType.EBOOK,
  } = props;

  const {
    name,
    authors: authorsBase,
    bookId,
    abookPreview,
    ebookPreview,
  } = item;

  const theme: ITheme = useTheme();

  const dispatch = useDispatch();

  const isPrimary = themeType === BooksCardBigThemeType.PRIMARY;

  const isLaptopL = useMediaQuery({ query: `(${Breakpoints.LAPTOP_L})` });

  const [getText] = useTranslate();

  const history = useHistory();

  const handleRedirect = () => history.push(vsprintf(RoutePath.BOOKS_DETAIL_PATH, [bookId]));
  const handleListen = (ev: MouseEvent<HTMLButtonElement>) => {
    ev.stopPropagation();
    dispatch(setAudioData(item));
  };
  const handleRead = (ev: MouseEvent<HTMLButtonElement>) => {
    ev.stopPropagation();
    history.push(vsprintf(RoutePath.BOOKS_READ_PATH, [bookId]));
  };

  const preview = (priorityPreview === BooksType.ABOOK && abookPreview) ? abookPreview : ebookPreview;
  const authors = getAuthorsLabel(authorsBase);

  const descriptionEl = (
    <>
      <BooksCardBigCaptionName>{textTrim(name, 100)}</BooksCardBigCaptionName>
      <BooksCardBigCaptionAuthors>{textTrim(authors, 30)}</BooksCardBigCaptionAuthors>
    </>
  );

  const buttonsEl = (
    <BooksCardBigButtons>
      <BooksCardBigButton
        onClick={handleListen}
        themeType={ButtonThemeType.SECONDARY}
        color={isPrimary ? theme.palette.primary : theme.palette.orange}
        icon={isLaptopL ? HeadphonesIcon : undefined}
        isPrimary
      >
        {getText(['words', 'listen'])}
      </BooksCardBigButton>
      <BooksCardBigButton
        onClick={handleRead}
        themeType={ButtonThemeType.MINOR}
        icon={isLaptopL ? ListIcon : undefined}
      >
        {getText(['words', 'read'])}
      </BooksCardBigButton>
    </BooksCardBigButtons>
  );

  return (
    <BooksCardBigContainer
      onClick={handleRedirect}
      isPrimary={isPrimary}
    >
      <BooksCardBigCover>
        <BooksCardBigCoverInner>
          <BooksCardBigCoverImg
            src={preview}
            decoding="async"
            onError={(e: any) => {
              e.target.onerror = null;
              e.target.src = placeholder;
            }}
          />
        </BooksCardBigCoverInner>
        {isLaptopL ? null : (
          <BooksCardBigCoverCaption>
            {descriptionEl}
          </BooksCardBigCoverCaption>
        )}
      </BooksCardBigCover>
      <BooksCardBigCaption>
        {isLaptopL ? descriptionEl : null}
        {buttonsEl}
      </BooksCardBigCaption>
    </BooksCardBigContainer>
  );
}

export default BooksCardBig;
